// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { LogLevel } from "@lib/logging/LogLevel";

/**
 * Provides an API for formatted logging.
 * Formats the messages before using an ILogger to log the messages.
 */
export interface ILog
{
  readonly name: string;
  logLevel: Nullable<LogLevel>;
  debug(format: string, ...args: any[]): void;
  error(format: string, ...args: any[]): void;
  info(format: string, ...args: any[]): void;
  trace(format: string, ...args: any[]): void;
  warn(format: string, ...args: any[]): void;
}